// extracted by mini-css-extract-plugin
module.exports = {"container":"TOVsSE","star":"_1ZDyz2","fillContainer":"_1rysD5","shine-lines":"_2kA-Cv"};